import { render, staticRenderFns } from "./closeEvent.vue?vue&type=template&id=2f90cb14&scoped=true&"
import script from "./closeEvent.vue?vue&type=script&lang=js&"
export * from "./closeEvent.vue?vue&type=script&lang=js&"
import style0 from "./closeEvent.vue?vue&type=style&index=0&id=2f90cb14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90cb14",
  null
  
)

export default component.exports